import pkg from '../../package.json';

export const environment = {
    production: true,
    version: pkg.version,
    apiServer: {
        controlCenter: 'https://api.everlightradiology.com/control-centre-api/'
    },
    apiBaseUrl: 'https://api.everlightradiology.com',
    auth: {
        issuer: 'https://login.everlightradiology.com/',
        logoutUrl:
            'https://login.everlightradiology.com/v2/logout?returnTo=https://cc.everlightradiology.com/logout&client_id=nOujM7rng4AQhcfUfarWqmYKelDl4eFE',
        redirectUri: 'https://cc.everlightradiology.com/login/callback',
        postLogoutRedirectUri: 'https://cc.everlightradiology.com/',
        clientId: 'nOujM7rng4AQhcfUfarWqmYKelDl4eFE',
        scope: 'openid profile email cc_api offline_access',
        responseType: 'code',
        customQueryParams: {
            audience: 'https://cc.everlightradiology.com/'
        },
        disableAtHashCheck: true
    },
    commitId: 'prod',
    serviceName: 'customers-app',
    googleAnalytics: {
        id: 'UA-162675716-1'
    },
    uiIdleHandler: {
        idleActionSeconds: 1800,
        timeoutCountdownSeconds: 300
    },
    launchDarkly: {
        clientId: '626243d133ee231525c01c90'
    },
    demandManagementDashboardUrl: 'https://superset.everlightradiology.com',
    datadog: {
        applicationId: 'f239f50c-7fe8-4596-8caf-2d90f89a208e',
        clientToken: 'pub81f5722d3a36d76e6e8d707b95450142',
        environment: 'production',
        service: 'customers-app',
        enabled: true
    }
};
